<template>
    <div v-if="appData.terminatedContract" class="default-message" v-t="'message.error_contract_termination'">
    </div>
    <div v-else class="user-panel">
        <table>
            <tr class="itemheader">
                <td style="width: 250px">
                    <div class="inner-panel">
                        <div class="scrollable">
                            <div class="tree-title" v-t="'message.menu_radio'"/>
                            <el-tree v-if="showTree"
                                     class="tree"
                                     :props="properties"
                                     :load="loadNode"
                                     lazy
                                     node-key="componentName"
                                     highlight-current
                                     @node-click="handleNodeClick"
                                     @node-collapse="handleNodeCollapse"
                                     :render-content="renderContent">
                            </el-tree>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="inner-panel">
                        <template v-if="selectedNode">
                            <div class="scrollable">
                                <component
                                    v-bind:selectedNode="selectedNode"
                                    v-bind:appData="appData"
                                    :is="selectedChild"
                                    :ref="selectedChild"
                                    @reloadTree="reloadTree">
                                </component>
                            </div>
                        </template>

                        <template v-else>
                            <div style="padding-top:100px;text-align:center">
                                <span v-t="'message.hint_select_radio_menu'"></span>
                            </div>
                        </template>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import commonUtil from '@/components/commonutil.js';
import IpRadioSetting from "@/components/pc/radio/ipradio/IpRadioSetting.vue";
import IpRadioGeneralAdminUserSetting from "@/components/pc/radio/ipradio/IpRadioGeneralAdminUserSetting.vue";
import IpRadioManual from "@/components/pc/radio/ipradio/IpRadioManual.vue";

export default {
    props: ['appData'],

    components: {
        IpRadioSetting,
        IpRadioGeneralAdminUserSetting,
        IpRadioManual
    },

    data() {
        return {
            showTree: true,

            selectedNode: null,

            properties: {
                label: 'label',
                isLeaf: 'isLeaf'
            },
        };
    },

    computed: {
        selectedChild: function() {
            if (this.selectedNode) {
                return this.selectedNode.data.componentName;
            }
        }
    },

    watch: {
        '$i18n.locale' () {
            this.reloadTree();
        },
        '$route' (to, from) {
            if (to.name === "Radio") {
                this.$refs.tree.setCurrentKey(null);
                this.selectedNode = null;
            }
        },
        'appData.isRadioTransitionUser'() { this.reloadTree(); },
        'appData.tenantAdminUser'() { this.reloadTree(); },
        'appData.radioManageUser'() { this.reloadTree(); },
    },

    methods: {
        loadNode(node, resolve) {
            var data = [];
            if (node.parent == null) {
                data.push({
                    componentName: "IpRadioSetting",
                    label: commonUtil.getMessageText(this.$i18n,"title_radio_setting"),
                    isLeaf: true
                });
                if (
                    this.appData.radioManageUser
                ) {
                    data.push({
                        componentName: "IpRadioGeneralAdminUserSetting",
                        label: commonUtil.getMessageText(this.$i18n, "title_general_admin_user"),
                        isLeaf: true
                    });
                }
                data.push({
                    componentName: "IpRadioManual",
                    label: commonUtil.getMessageText(this.$i18n,"title_manual"),
                    isLeaf: true
                });
                resolve(data);
            }
        },
        handleNodeClick(data, node, elNode) {
            this.selectedNode = node;
        },
        handleNodeCollapse(data, node, elNode) {
            node.expand();
        },
        renderContent(h, { node, data, store }) {
            let objectIcon = require("@/assets/square_green.svg");
            let height = "6px";
            return h("span", [h("img", { attrs: { src: objectIcon ,height: height, style: "vertical-align: middle" } }), h("span", node.label)]);
        },
        reloadTree() {
            this.showTree = false;
            this.$nextTick(() => {
                this.showTree = true
            })
        },
    },
    created: function() {
    },
    mounted: function() {
    }
}
</script>

<style scoped>

table {
    height: 100%;
    width: 100%;
    border-collapse: collapse;
}

.tree-title {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
    width: 100%;
    vertical-align: middle;
    background-color: #f6f6f6;
    color: #848991;
}

.user-panel {
    height: 100%;
    background-color: #ffffff;
}

.inner-panel {
    position:relative;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
    background-color: #ffffff;
}

.scrollable {
    overflow: auto;
    position: absolute;
    top: 0;
    right:0;
    bottom: 0;
    left: 0;
    border-top: solid;
    border-color: #eee;
    border-width: 1px;
}

</style>
